import icon from './language.png.js';
import template from './graph_widget_view.html';
import templateMaxView from './graph_widget_max.html';
import templateReportView from './graph_widget_report.html';

angular.module('MW.InsDashboard.topLangWidget', [
    'MW.Framework.TranslationService',
    'MW.Dashboard.DashboardWidgetService',
    'MW.InsDashboard.insightsBackendService',
    'DashboardChartConfigService',
    'MW.Framework.GeoService',
    'MW.InsDashboard.InsWidgetConfigService',
    'MW.InsDashboard.InsightsDataMaps',
    'MW.InsDashboard.TransformSegment',
    'MW.InsDashboard.ChartDataService',
    'MW.Framework.CoreCommon',
    'CoreChartObject',
    'CoreColorService',
    'LanguageService',
    'MW.Dashboard.DashboardStateService',
    'MW.Framework.CoreBreadcrumb',
    'MW.Framework.AppChromeService',
    'MW.Configuration',
    'MW.Framework.InformationTypeService',
    'MW.Dashboard.Base64Service',
    'MW.DashboardLegacy.Constants'
])
.directive('topLangWidget', [
    '$q',
    'translationService',
    'DashboardWidgetService',
    '$filter',
    'insightsBackendService',
    'DashboardChartConfigService',
    'GeoService',
    'InsWidgetConfigService',
    'InsightsDataMaps',
    'TransformSegment',
    'ChartDataService',
    'CoreCommon',
    'CoreChartObject',
    'CoreColorService',
    'LanguageService',
    '$routeParams',
    '$location',
    'DashboardStateService',
    'Breadcrumb',
    'Base64Service',
    function($q, translationService, DashboardWidgetService, $filter, insightsBackendService, DashboardChartConfigService, GeoService, InsWidgetConfigService, InsightsDataMaps, TransformSegment, ChartDataService, CoreCommon, CoreChartObject, CoreColorService, LanguageService, $routeParams, $location, DashboardStateService, Breadcrumb, Base64Service){

    var languageSegmentWidget = DashboardWidgetService.getWidget('top-lang-widget');

    languageSegmentWidget.editViewFile = 'graph_widget_view';
    languageSegmentWidget.userViewFile = 'graph_widget_view';
    languageSegmentWidget.maximizedViewFile = 'graph_widget_max';
    languageSegmentWidget.reportViewFile = 'graph_widget_report';

    var languageSegmentWidgetController = function($scope){
        $scope.insightsService = 'languageHistograms';

        $scope.initSettings = function(){
            InsWidgetConfigService.readyWidgetData($scope);

            if($scope.widget.settings.selectedGraphType.id === 'table' && $scope.isReport) {
                $scope.graphType = 'table';
            }
        }
    };

    var languageSegmentWidgetLink = function(scope, element) {
        var getLabelFormatFromSettings = function getLabelFormatFromSettings() {
                return CoreCommon.isUsable(scope.widget.settings.labelFormat) ? scope.widget.settings.labelFormat[0].id : scope.widget.availableLabelFormat[0].id;
            },
            defaultGraph = scope.widget.availableChartTypes[0].id,
            defaultColors = CoreColorService.getColors('default'),
            inputColor = CoreColorService.colors.blueMalibu;

        if(scope.widget.settings.searchIds && scope.widget.settings.searchIds.length === 1) {
            var encodedInputId = Base64Service.encode(scope.widget.settings.searchIds[0].searchId);

            if(typeof DashboardStateService.inputIdsToColorMapping.colors[encodedInputId] === 'undefined') {
                inputColor = DashboardStateService.inputIdsToColorMapping.colors[encodedInputId] = defaultColors[DashboardStateService.inputIdsToColorMapping.colorIndex++];
            } else {
                inputColor = DashboardStateService.inputIdsToColorMapping.colors[encodedInputId];
            }
        } else if(scope.widget.settings.inputs && scope.widget.settings.inputs.length === 1) {
            var encodedInputId = Base64Service.encode(scope.widget.settings.inputs[0].id);

            if(typeof DashboardStateService.inputIdsToColorMapping.colors[encodedInputId] === 'undefined') {
                inputColor = DashboardStateService.inputIdsToColorMapping.colors[encodedInputId] = defaultColors[DashboardStateService.inputIdsToColorMapping.colorIndex++];
            } else {
                inputColor = DashboardStateService.inputIdsToColorMapping.colors[encodedInputId];
            }
        }

        var getLabelVisibilityFromSettings = function getLabelVisibilityFromSettings() {
            return CoreCommon.isUsable(scope.widget.settings.labelVisibility) ? scope.widget.settings.labelVisibility[0].id : scope.widget.availableLabelVisibility[0].id;
        };
        scope.labelVisibility = (getLabelVisibilityFromSettings() == 1) ? false : true;
        scope.widgetIsLoading = false;
        scope.noDataFromServer = false;
        scope.serviceError = false;
        scope.notConfigured = false;
        scope.showTable = false;
        scope.searches = [];
        scope.graphType =  defaultGraph;
        scope.drillDown = InsWidgetConfigService.dateGranularityDrilldown;
        scope.widget.settings.chart = {
            xAxisType: "category"
        };
        scope.tableSettings = {
            enabled: true,
            data: {},
            rowTitle: 'Languages',
            summaryTitle: translationService.getLocalizedString('Total'),
            countField: 'count',
            percentField: 'percent',
            titleField: 'name'
        };
        scope.documentRequest = {};

        scope.selectedLabelFormatId = getLabelFormatFromSettings(); // Getting Label Format id from widget.settings

        if(scope.selectedLabelFormatId == 1) { // Number
            scope.widget.settings.chart.percentageMode = false;
        } else if (scope.selectedLabelFormatId == 2) { // Percentage
            scope.widget.settings.chart.percentageMode = true;
        }

        // Run our updating function when we recieve an update notification from a widget higher in the scope tree.
        scope.$on('widgetFiltersUpdated', function() { scope.fetchData(true) });

        var checkRoutes = function checkRoutes() {
            if($routeParams.language) {
                updateBreadcrumb($routeParams.language);
            }
        };

        scope.fetchData = function(skipReinitSettings) {
            var processData = function processData(data) {
                var chartBasics = {},
                languageName,
                doChartAnimation,
                sharedChart,
                viewName = 'user';

                if(scope.isReport){
                    viewName = 'report';
                } else if(scope.isMaximized){
                    viewName = 'max';
                }

                chartBasics = {
                    type: defaultGraph,
                    view: viewName,
                    percent: scope.widget.settings.chart.percentageMode,
                    reportType: scope.reportType
                }

                scope.chartData = {};
                scope.widgetIsLoading = false;

                doChartAnimation = InsWidgetConfigService.getChartAnimationStatus(scope.widget.id+scope.isMaximized);
                sharedChart = {
                    xAxis: {
                        labels: {
                            align: 'left',
                            x: 6,
                            y: 5,
                            style: {
                                color: CoreColorService.colors.grey80,
                                whiteSpace: 'nowrap'
                            },
                            useHTML: true,
                            formatter: function() {
                                languageName = LanguageService.getLanguage(this.value) ? LanguageService.getLanguage(this.value).name : this.value;
                                if(languageName == "zh-Hans") {
                                    languageName = 'Chinese Simplified';
                                } else if (languageName == "zh-Hant") {
                                    languageName = "Chinese Traditional";
                                }

                                var currentIdx = 0;
                                for (var idx = 0, max = this.axis.categories.length; idx < max; idx++){
                                    if (this.axis.categories[idx] == this.value){
                                        currentIdx = idx;
                                        break;
                                    }
                                }
                                var template, dataLabel;
                                if(scope.widget.settings.chart.percentageMode)
                                    dataLabel = data.series[0].data[currentIdx].percent.toFixed(2) + '%';
                                else
                                    dataLabel = DashboardChartConfigService.formatDataLabels(data.series[0].data[currentIdx].volume);

                                var chartWidth = this.chart.clipBox.height,
                                    ourWidth = 0.65 * chartWidth;
                                languageName = translationService.getLocalizedString(languageName);
                                var retVal = DashboardChartConfigService.getTruncatedText(languageName, ourWidth, this.chart.userOptions.xAxis.labels.style);
                                if(scope.labelVisibility)
                                    template = '<div style="font-size: 11px; text-align: left; text-shadow: rgb(255, 255, 255) 0px 0px 6px, rgb(255, 255, 255) 0px 0px 3px; padding: 1px; margin-top: -2px;">' 
                                        + retVal + '&nbsp;&mdash;&nbsp;' + dataLabel
                                        + '</div>';
                                else
                                    template = '<div style="font-size: 11px; text-align: left; text-shadow: rgb(255, 255, 255) 0px 0px 6px, rgb(255, 255, 255) 0px 0px 3px; padding: 1px; margin-top: -2px;">' + retVal + '</div>';

                                return template;
                            }
                        },
                        type: 'category'
                    },
                    tooltip: {
                        borderWidth: 2,
                        shape: 'square',
                        backgroundColor: "rgba(255,255,255,0)",
                        borderRadius: 2,
                        style: {
                            padding: 0,
                            margin: 0
                        },
                        shadow: true,
                        useHTML: true,
                        percentageDecimals: 2,
                        backgroundColor: "rgba(255,255,255,1)",
                        formatter: function() {

                            var retVal = DashboardChartConfigService.addNumericSymbol(this.point.volume);
                            var pcnt = this.point.percent;
                            languageName = LanguageService.getLanguage(this.point.category) ? LanguageService.getLanguage(this.point.category).name : this.point.category;
                            if(languageName == "zh-Hans") {
                                languageName = 'Chinese Simplified';
                            } else if (languageName == "zh-Hant") {
                                languageName = "Chinese Traditional";
                            }
                            languageName = translationService.getLocalizedString(languageName);
                            var retString = languageName + ": " + retVal + " (" + Highcharts.numberFormat(pcnt) + "%)";
                            return retString;
                        }
                    }
                };


                scope.chartData = CoreCommon.mergeRecursive(scope.chartData, sharedChart);
                if (scope.isMaximized) {
                    var maximizedChart = {
                        chart: {
                            marginRight: 13,
                            animation: false
                        },
                        yAxis: {
                            gridLineWidth: 1,
                            max: scope.widget.settings.chart.percentageMode ? 100 : null,
                            title: {
                                text: translationService.getLocalizedString('Results'),
                                offset: 30,
                                align: 'middle'
                            },
                            labels: {
                                useHTML: true,
                                formatter: InsWidgetConfigService.getSegmentationYAxisFormatFunction(scope.widget.settings.chart),
                                overflow: 'justify'
                            }
                        },
                        legend: {
                            enabled: false
                        },
                        plotOptions: {
                            bar: {
                                color: inputColor,
                                pointWidth: 28,
                                point: {
                                    events: {
                                        click: function (event) {

                                            scope.languageCode = (event.point) ? event.point.category : event.target.category;
                                            scope.documentRequest['language'] = scope.languageCode;
                                            $routeParams.language = scope.languageCode;
                                            if(typeof scope.inputs !== 'undefined') {
                                                scope.internalDrillDown(scope.inputs[0]['id']);
                                            }else{
                                                scope.internalDrillDown(scope.searches[0]['agent']);
                                            }
                                        }
                                    }
                                }
                            },
                            series: {
                                animation: doChartAnimation
                            }
                        }
                    };
                    scope.chartData = CoreCommon.mergeRecursive(scope.chartData, maximizedChart);
                    scope.chartData = CoreCommon.mergeRecursive(scope.chartData, data);
                } else {

                    //dashboard view
                    var baseChart = {
                        chart: {
                            spacingLeft: 0,
                            spacingTop: 0,
                            marginRight: 12
                        },
                        yAxis: {
                            title: {
                                text: translationService.getLocalizedString('Results'),
                                align: 'middle',
                                offset: 15
                            }
                        },
                        plotOptions: {
                            bar: {
                                borderWidth: 0,
                                pointWidth: 28,
                                color: inputColor,
                                dataLabels: {
                                    enabled: false,
                                    formatter: function () {
                                        return Highcharts.numberFormat(this.percent) + '%';
                                    }
                                }
                            },
                            series: {
                                animation: doChartAnimation
                            }
                        }
                    };
                    var dashboardRequestData = data;
                    dashboardRequestData.series[0].data = dashboardRequestData.series[0].data.slice(0, 6);

                    scope.chartData = CoreCommon.mergeRecursive(scope.chartData, dashboardRequestData);
                    scope.chartData = CoreCommon.mergeRecursive(scope.chartData, baseChart);
                }

                scope.chartData = new CoreChartObject(chartBasics, scope.chartData);
            };

            if(!skipReinitSettings) {
                scope.initSettings(); //creates scope.chartDataObject use by ChartDataService
            }

            if(!scope.readyToQuery) return;

            scope.highchart = true;
            scope.widgetIsLoading = true;
            scope.serviceError = false;
            scope.noDataFromServer = false;
            scope.notConfigured = false;
            scope.chartDataObject.fetchDataForPreviousRange = true;
            scope.chartDataObject.insObject = scope.insightsService;
            scope.chartDataObject.dataMap = InsightsDataMaps.datamapCountryVolume;
            scope.chartDataObject.queryParameters.size = 20;
            scope.chartDataObject.percent = scope.widget.settings.chart.percentageMode;
            scope.chartDataObject.chartTransformFunction = TransformSegment[scope.graphType];
            scope.documentRequest = {};

            if(scope.graphType == 'table') {
                // Callback for table view
                scope.chartDataObject.callback = function tableGeoCallback(data) {
                    scope.tableSettings.data = data.table;
                    if(scope.widget.settings.chart.percentageMode === true){
                        scope.tableSettings.summary = data.percentSummary;
                        scope.tableSettings.displayField = scope.tableSettings.percentField;
                    } else {
                        scope.tableSettings.summary = data.countSummary;
                        scope.tableSettings.displayField = scope.tableSettings.countField;
                    }
                    scope.widgetIsLoading = false;
                    scope.tableSettings.drilldown = function drilldown(datapoint){
                        scope.documentRequest['language'] = datapoint.filterField;
                        scope.languageCode = datapoint.filterField;
                        $routeParams.language = datapoint.filterField;
                        if(typeof scope.inputs !== 'undefined') {
                            scope.internalDrillDown(scope.inputs[0]['id']);
                        }else{
                            scope.internalDrillDown(scope.searches[0]['agent']);
                        }
                    };
                    scope.tableSettings.tooltip = function tooltip(datapoint){
                        return translationService.getLocalizedString('Top Languages') + ': ' + datapoint.count;
                    };
                    scope.showTable = true;
                }
            } else {
                // Callback for chart view
                scope.chartDataObject.callback = function geoCallback(data) {
                    checkRoutes();
                    processData(data);
                };
            }

            ChartDataService.fetchAllData(scope.chartDataObject, scope.$id).catch(function onCatch(error) {
                scope.$emit('chartData_fetchAllDataError', error);
            });
        };

        if(scope.widget.hasRequiredSettings()){
            scope.fetchData();
        } else {
            scope.notConfigured = true;
        }

        scope.animate = true;
        scope.togglePercentage = function togglePercentage (id) {
            var mode;
            scope.selectedLabelFormatId = id;
            if(id === 1) {
                mode = false;
            } else if (id === 2) {
                mode = true;
            }

            scope.animate = false;
            scope.widget.settings.chart.percentageMode = mode;
            scope.fetchData(true);
        };

        var getRequestparams = function getRequestparams(url) {
            var params = {};
            var searchStr = url.split("?")[1];
            if(searchStr !== undefined) {
                var paramsStr = searchStr.split("&");
                for(var key in paramsStr) {
                    params[paramsStr[key].split("=")[0]] = paramsStr[key].split("=")[1];
                }
            }
            return params;
        }

        var resetFiltersQueryRequestParams = function resetFiltersQueryRequestParams() {
            var appliedFilters = scope.widget.filters;
            for(var prop in appliedFilters) {
                InsWidgetConfigService.queryRequestSettings[prop.toLowerCase()] = appliedFilters[prop].value.join();
            }
            if(!appliedFilters.hasOwnProperty('Language')) {
                InsWidgetConfigService.queryRequestSettings.language = null;
            }
        };

        scope.$on('$locationChangeSuccess', function onCoreBreadcrumbLocationChangeSuccess(event, newVal, oldVal) {
            var newParams = getRequestparams(newVal),
                oldParams = getRequestparams(oldVal);

            if(newVal == oldVal) {return;}

            if(newParams.date) {
                //correctly parsing the '+' character in encoded date in newParams
                newParams.date = newParams.date.replace(/(%2B)/g, '+');
            }
            updateBreadcrumb(newParams.language, newParams.date);
            if(oldParams.language !== undefined && newParams.language === undefined) {
                if(scope.documentRequest.language) {
                    delete scope.documentRequest.language;
                }
                resetFiltersQueryRequestParams();
                InsWidgetConfigService.dateGranularityDrilldown(false, undefined, scope);
            } else if((newParams.language !== undefined && oldParams.language === undefined) || (newParams.language !== undefined && oldParams.language !== undefined && ((newParams.language !== oldParams.language) || (newParams.date !== oldParams.date)))) {
                // In this case, the user probably used the browser's Forward button to go back to a drilldown.
                // Since we don't have the benefit of a click trigger, we need to do it manually here
                scope.documentRequest['language'] = newParams.language;
                if(typeof scope.inputs !== 'undefined'){
                    scope.drillDown(scope.inputs[0].id, undefined, scope);
                } else {
                    scope.drillDown(scope.searches[0].agent, undefined, scope);
                }
            }
        });

        scope.internalDrillDown = function internalDrillDown(id){
            if(scope.isMaximized) {
                var queryParams = {
                    drilled: true
                };

                if($routeParams.language) {
                    queryParams['language'] = $routeParams.language;
                }

                updateLocationURL(queryParams);
            }
            scope.drillDown(id, undefined, scope);
            /*if(scope.graphType !== 'table') {
                scope.$apply();
            }*/
        };

        var updateLocationURL = function updateLocationURL(queryParams) {
            var maxPath,
                editMode = $routeParams.editMode || false,
                urlQuery = {
                    editMode: editMode
                };

            if($location.path().indexOf('/dashboard/index') === 0) {
                maxPath = '/dashboard/viewer/'+DashboardStateService.getDefaultDashboard()+'/' + scope.widget.id;
            } else if($routeParams.dashboardId && $routeParams.dashboardId != 'current' && $routeParams.dashboardId != 'new'){
                maxPath = $location.path();
            } else {
                maxPath = '/dashboard/'+($location.path().indexOf('builder') === -1?'viewer':'builder')+'/'+(DashboardStateService.currentDashboard._id || 'current') + '/' + scope.widget.id;
            }

            if(!$routeParams.drilled) {
                queryParams['drilled'] = true;
            }

            for(var prop in queryParams) {
                urlQuery[prop] = queryParams[prop];
            }

            updateBreadcrumb(scope.languageCode);
            $location.path(maxPath).search(urlQuery);
        };

        var updateBreadcrumb = function updateBreadcrumb(languageCode) {
            var dashboardPath,
                widgetPath,
                selectionTitle = '',
                dashboardMode = $location.path().indexOf('/dashboard/viewer') !== -1 ? '/dashboard/viewer/' : '/dashboard/builder/',
                langName = '';
                if(languageCode == "zh-Hans") {
                    langName = 'Chinese Simplified';
                } else if (languageCode == "zh-Hant") {
                    langName = "Chinese Traditional";
                } else if(languageCode !== 'undefined'){
                    langName = LanguageService.getLanguage(languageCode) ? LanguageService.getLanguage(languageCode).name : '';
                }

            scope.breadcrumbs = [];
            scope.breadcrumbs = [Breadcrumb.build({
                name: 'Analyze',
                link: '/analyze/home',
                isClickable: false
            })];

            dashboardPath = '/dashboard/viewer/' + scope.dashboard._id;

            selectionTitle += langName ? langName : '';
            scope.breadcrumbs.push(Breadcrumb.build({name: scope.dashboard.title, link: dashboardPath }));

            if(selectionTitle === '') {
            var mypath = '/dashboard/viewer/'+scope.dashboard._id,
                subCrumbs = [],
                myNewPath,
                subCrumbVal;

                if(scope.dashboard.containers[0].widgets.length > 1) {
                    Object.keys(scope.dashboard.containers[0].widgets).forEach(function(key){
                        myNewPath = dashboardMode + scope.dashboard._id + '/' + scope.dashboard.containers[0].widgets[key].id + '?editMode=false';
                        subCrumbVal = {
                            name: scope.dashboard.containers[0].widgets[key].title,
                            link: myNewPath,
                            isClickable: function isClickable() { return true; }
                        };

                        subCrumbs.push(subCrumbVal);
                    });
                }
                scope.breadcrumbs.push(Breadcrumb.build({name: scope.widget.title, subCrumbs: subCrumbs}));
            } else {
                widgetPath = dashboardMode + scope.dashboard._id + '/' + scope.widget.id + '?editMode=false';
                scope.breadcrumbs.push(Breadcrumb.build({name: scope.widget.title, link: widgetPath}));
                scope.breadcrumbs.push(Breadcrumb.build({name: selectionTitle}));
            }
        }

        var resetBreadcrumb = function resetBreadcrumb() {
            var maxPath,
                editMode = $routeParams.editMode || false,
                urlQuery = {
                    editMode: editMode
                };

            if($location.path().indexOf('/dashboard/index') === 0) {
                maxPath = '/dashboard/viewer/'+DashboardStateService.getDefaultDashboard()+'/' + scope.widget.id;
            } else if($routeParams.dashboardId && $routeParams.dashboardId != 'current' && $routeParams.dashboardId != 'new'){
                maxPath = $location.path();
            } else {
                maxPath = '/dashboard/'+($location.path().indexOf('builder') === -1?'viewer':'builder')+'/'+(DashboardStateService.currentDashboard._id || 'current') + '/' + scope.widget.id;
            }

            updateBreadcrumb();
            $location.path(maxPath).search(urlQuery);
        };

        scope.toggleGraph = function toggleGraph(graphType) {
            if(InsWidgetConfigService.queryRequestSettings.language){
                InsWidgetConfigService.queryRequestSettings.language = null;
            }
            var oldGraphType = scope.graphType;
            scope.graphType = graphType;
            scope.showTable = false;
            resetBreadcrumb();
            scope.fetchData();
            scope.initSettings();
        };

        scope.toggleTable = function toggleTable() {
            if(InsWidgetConfigService.queryRequestSettings.language){
                InsWidgetConfigService.queryRequestSettings.language = null;
            }
            scope.graphType = 'table';
            resetBreadcrumb();
            scope.fetchData();
        };
    };

    return new WidgetDirective(languageSegmentWidget, languageSegmentWidgetLink, languageSegmentWidgetController);
}])
.run(['DashboardWidgetService', 'translationService', 'InformationTypeService', 'CoreCommon','InsWidgetConfigService', 'DASHBOARD_LEGACY_URL', function (DashboardWidgetService, translationService, InformationTypeService, CoreCommon, InsWidgetConfigService, DASHBOARD_LEGACY_URL) {
    DashboardWidgetService.register({
        name: translationService.getLocalizedString('Top Languages'),
        app: 'ins_dashboard',
        description: translationService.getLocalizedString('The Top Language widget provides insight into how coverage of a ' +
                                                           'brand, product, event or topic is broken down by media outlet. The ' +
                                                           'widget displays a ranking of the top 10 Languages where a topic is ' +
                                                           'covered most frequently and thereby helps you understand in which ' +
                                                           'Languages a topic is trending.'),
        directive: 'top-lang-widget',
        icon,
        defaultSettings: {
            'width': 'third',
            'title': 'Title',
            'description': '',
            source: [],
            'maxAgents': 1
        },
        displayOrder: 11,
        allowExport: true,
        requiredSettings: ['dateRange'],
        availableSettings: ['dateRange','title','news','social','broadcast','tags','labelFormat', 'labelVisibility'],
        availableChartTypes:[{
            name:'Bar', id:'bar'
        }],
        getDefaultChartType: function() {
            if (CoreCommon.isUsable(this.settings.searchIds) && this.settings.searchIds.length !== 0) {
                return this.availableChartTypes[0];
            }
        },
        hasRequiredSettings: function(){
            var _widget = this;
            return InsWidgetConfigService.hasSelectedAnInput(_widget);
        },
        template,
        templateMaxView,
        templateReportView
    });

}]);
